export default {
  common: {
    back: '뒤로',
    cancel: '취소',
    noBooking: '예약 정보를 찾을 수 없습니다',
    openFromBooking: '예약 상세에서 다시 접속해 주세요.',
    loadFailed: '불러오지 못했습니다',
    retry: '다시 시도'
  },
  views: {
    change: {
      policy:
        '변경 정책: 동일한 이용일에 원래 열차 출발 전이며 좌석이 남아 있는 열차로만 변경할 수 있습니다. 여러 번 변경할 수 있습니다. 출발역, 도착역 및 인원은 변경할 수 없습니다.',
      confirmSelect: '변경 확인',
      submittedTitle: '예약이 변경되었습니다',
      submittedThanks: '홈으로 돌아가 변경된 티켓을 확인해 주세요.'
    },
    trainList: {
      vehicleInfo: '열차 정보',
      ticketName: '오다큐 로망스카',
      travelDate: '이용일: ',
      route: '출발 및 도착: ',
      ticketCount: '예약 인원: ',
      trainType: '차종: ',
      seatClass: '좌석 유형: ',
      preference: '좌석 선호: ',
      preOrderNote: '',
      selectStation: '역 선택',
      from: '출발',
      to: '도착',
      swap: '출발역과 도착역 바꾸기',
      selectTrain: '열차 선택',
      select: '선택',
      book: '예약',
      seatAvailable: '좌석 여유',
      seatLimited: '잔여석 부족',
      soldOut: '매진',
      notOnSale: '판매 전',
      noTimeRanges: '이용 가능한 시간대가 없습니다',
      noTrains: '이 시간대에 이용 가능한 열차가 없습니다'
    },
    seat: {
      title: '좌석을 선택해 주세요',
      ticketCount: '예약 인원: ',
      selectMethod: '좌석 선택 방법',
      selectByPreference: '조건으로 지정',
      selectBySeatMap: '좌석표에서 지정',
      preference: '위치 선호',
      car: '차량',
      noCarPreference: '지정 안 함',
      selectSeats: '좌석 선택 ({{selected}}/{{total}})',
      seatLabel: '좌석 {{seat}}',
      seatMapDescription:
        '*A/D 좌석은 창가, B/C 좌석은 통로 측입니다. 여러 차량에 걸쳐 좌석을 지정할 수 없습니다.',
      noSeats: '현재 차량에는 선택 가능한 좌석이 없습니다',
      noTrain: '열차가 선택되지 않았습니다',
      selectTrainFirst: '돌아가서 열차를 선택해 주세요.',
      next: '다음'
    },
    confirm: {
      trainConfirm: '열차 확인',
      ticketName: '오다큐 로망스카',
      route: '출발 및 도착: ',
      travelDate: '이용일: ',
      ticketCount: '예약 수량: ',
      trainType: '차종: ',
      seatClass: '좌석 종류: ',
      preference: '좌석 선호: ',
      confirmSelect: '선택 확인',
      noTrain: '열차가 선택되지 않았습니다',
      selectTrainFirst: '돌아가서 열차를 선택해 주세요.'
    },
    submitted: {
      title: '예약이 접수되었습니다',
      thanks: '예약해 주셔서 감사합니다. 홈에서 발권 결과를 확인해 주세요',
      ticketName: '오다큐 로망스카',
      route: '출발 및 도착: ',
      travelDate: '이용일: ',
      ticketCount: '예약 수량: ',
      trainType: '차종: ',
      seatClass: '좌석 종류: ',
      preference: '좌석 선호: ',
      backHome: '홈으로'
    },
    notFound: {
      title: '페이지를 찾을 수 없습니다',
      message: 'URL을 확인하고 다시 시도해 주세요.'
    }
  }
};
